import React, { useEffect, useState } from "react";
import { FormValidator, useFormValidator, Inputs } from "coaz-ui";
import client from "../client";

const AddTopic = ({ params, submitRef, setLoading, setEnableSubmit }) => {
  const cpdId = params ? params.cpdId : null;
  const [topic, setTopic] = useState({});
  const [course, setCourse] = useState(null); 
  const { request, errorMessage } = client;

  const submit = async () => {
    if (!course) return { message: "The CPD could not be loaded." };

    try {
      await request("POST", "topics", {
        ...topic,
        cpd: course,
        course: course,
      });
      return { message: "Successful", success: true };
    } catch (error) {
      return { message: errorMessage(error) };
    }
  };

  const [register, handleChange, handleSubmit, errors] = useFormValidator(submit);

  const onChange = (e) => {
    const value = e.target.value;
    setTopic((prev) => ({ ...prev, [e.target.name]: value === "" ? null : value }));
  };

  const inputs = [
    {
      label: "CPD",
      type: "text",
      name: "cpd",
      disabled: true,
      value: course && course.name ? course.name : "",
      placeholder: "CPD...",
    },
    {
      label: "Name",
      type: "text",
      name: "name",
      value: topic.name ? topic.name : "",
      placeholder: "Enter name...",
      onChange: (e) => handleChange(e, onChange),
      register: register,
      checks: ["empty"],
      errors: errors,
    },
  ];

  useEffect(() => {
    if (handleSubmit) {
      submitRef.current = { submit: handleSubmit };
      setEnableSubmit(true);
    } else {
      submitRef.current = null;
      setEnableSubmit(false);
    }
    return () => {
      submitRef.current = null;
    };
  }, [handleSubmit]);

  useEffect(() => {
    (async () => {
      if (!cpdId) return;
      setLoading && setLoading(true);
      try {
        const response = await request("GET", `cpds/${cpdId}`);
        if (response && response.ref) setCourse(response);
      } catch (error) {
        console.log(error);
      }
      setLoading && setLoading(false);
    })();
  }, [cpdId]);

  return (
    <FormValidator>
      <div className="flex flex-col w-full h-auto shrink-0 space-y-4">
        <Inputs inputs={inputs} minWidth={240} onSubmit={handleSubmit} />
      </div>
    </FormValidator>
  );
};

export default AddTopic;